import Icon from '../../components/Icon.vue'

Icon.register({"regular/clipboard":{"width":384,"height":512,"paths":[{"d":"M336 64H256C256 28.7 227.3 0 192 0S128 28.7 128 64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V112C384 85.5 362.5 64 336 64zM330 464H54A6-6 0 0 0 48 458V118A6-6 0 0 0 54 112H96V148C96 154.6 101.4 160 108 160H276C282.6 160 288 154.6 288 148V112H330A6-6 0 0 0 336 118V458A6-6 0 0 0 330 464zM192 40C205.3 40 216 50.7 216 64S205.3 88 192 88 168 77.3 168 64 178.7 40 192 40"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/clipboard.js
// module id = 9loC
// module chunks = 0